import measurement from './measurement';
import navHelper from './navHelper';
import utility from './utility';
import constants from './constants';
import validationHelper from './validationHelper';
import widgetHelper from './widgetHelper';

export default {
  name: 'pageNavigationHelper',
  inject: ['$validator'],
  mixins: [measurement, navHelper, widgetHelper, utility, validationHelper],
  data() {
    return {
      primaryButtonDisabled: 'N',
      hasInvalidFields: false,
      preventRep: false,
    };
  },
  created() {
    document.addEventListener('value-changed', (ev) => {
      if (ev.detail && !ev.detail.valid) {
        this.hasInvalidFields = true;
      }
    });
  },
  methods: {
    isRepOnRCPage() {
      return this.uc_isRep && this.cs_stateName === 'review-and-confirm';
    },
    performNavigation(navAction, haltNavigation = false) {
      this.$store.commit('currentState/updateField', {
        path: 'navAction',
        value: navAction,
      });
      this.routeEngine(this.getInstanceData(), haltNavigation);
    },
    performFinalPageNavigation() {
      window.location.assign(this.rc_exitUrl);
    },
    submitIgoForm() {
      let regType;
      let n;
      const str = document.location.pathname;
      if (str) {
        n = str.lastIndexOf('/');
        regType = str.substr(n + 1);
      }
      this.regType.value = regType;
      if (regType === 'rolloverIRA') {
        this.igoForm.action = this.pd_envConfig.toaURL;
      } else {
        this.igoForm.action = this.pd_envConfig.portfolioSummaryUrl;
      }
      this.igoForm.submit();
    },
    performIGOageNavigation() {
      this.submitIgoForm();
    },
    performPIPageNavigation() {
      if (this.shouldCall2FAWidget(
        this.cs_stateName,
        this.uc_isCustomer,
        this.uc_isRep,
        this.routeId,
      )) {
        this.handleWidgetSubmit();
      }
    },
    navigateState(navAction) {
      if (this.cs_editMode) {
        this.trackEditNavigation(navAction);
      }
      this.performNavigation(navAction);
    },
    trackEditNavigation(navAction) {
      switch (navAction) {
        case 'next':
          this.track('nav-save', 'interaction');
          break;
        case 'previous':
          this.track('nav-cancel', 'interaction');
          break;
        default:
          break;
      }
    },
    resetInvalidFieldOnPage() {
      this.hasInvalidFields = false;
    },
    showPrevious() {
      let showPrevious = true;
      if (!this.cs_editMode) {
        if ((this.routeId === 'brokerage' || this.routeId === 'fcma') && this.cs_stateName === 'employment-information') {
          showPrevious = false;
        } else {
          showPrevious = this.pd_pageData.showPreviousStates.indexOf(this.cs_stateName) > -1;
        }
      }
      return showPrevious;
    },
    handleSecondaryButtonClick(navAction) {
      this.performNavigation(navAction);
    },
    $_setFocus() {
      const errorElements = '.input-error, input[aria-invalid]:not([aria-invalid="false"]), select[aria-invalid]:not([aria-invalid="false"])';
      const firstErrorElement = document.querySelector(errorElements);
      if (firstErrorElement) {
        if (!!window.MSInputMethodContext && !!document.documentMode) {
          setTimeout(() => {
            firstErrorElement.focus();
          }, 5);
        } else {
          firstErrorElement.focus();
        }
      }
    },
    saveHTML(state) {
      const needsArchive = [
        'review-and-confirm',
        'review-and-confirm-is',
        'agree-to-terms',
      ];
      if (needsArchive.includes(state)) {
        const archiveHTML = this.captureHTML();
        switch (state) {
          case 'review-and-confirm-is':
          case 'review-and-confirm':
            this.pu_reviewAndConfirmHTML = this.saveRCPageUserInputs(
              archiveHTML,
              this.pu_cashPosition,
            );
            break;
          case 'agree-to-terms':
            this.pu_agreeTermsHTML = this.saveUserInputs(
              archiveHTML,
              this.pu_taxWithHolding,
            );
            break;
          default:
            break;
        }
      }
    },
    setEnablePrimaryButton() {
      this.primaryButtonDisabled = 'N';
    },
    setDisablePrimaryButton() {
      switch (this.cs_stateName) {
        case 'agree-to-terms':
        case 'personal-information':
        case 'review-and-confirm':
          this.primaryButtonDisabled = 'Y';
          break;
        default:
          break;
      }
    },
    performPageValidation(navAction) {
      this.resetInvalidFieldOnPage();
      const validatedres = this.validateAllFields();
      return new Promise((resolve) => {
        this.$validator.validateScopes().then((isValid) => {
          if (isValid && !this.hasInvalidFields && validatedres === true) {
            return resolve(true);
          }
          this.track(`nav-${navAction}-error`, 'interaction');
          this.$_setFocus();
          return resolve(false);
        });
      });
    },
  },
  computed: {
    isPrimaryButtonDisabled() {
      return this.primaryButtonDisabled;
    },
    getPageExitUrl() {
      let returnVal;
      const regType = this.getRegType(document.location.pathname);
      if (this.cs_stateName === 'customer-igo' && regType !== constants.ROLLOVERIRA_REGTYPE) {
        returnVal = this.pd_envConfig.portfolioSummaryUrl;
      } else if (this.$globalData.tStoreResponse && this.$globalData.tStoreResponse.exitURL) {
        if (this.$globalData.tStoreResponse.exitURL.method === 'POST') {
          returnVal = { url: this.$globalData.tStoreResponse.exitURL.url, method: 'POST' };
        } else {
          returnVal = this.$globalData.tStoreResponse.exitURL.url;
        }
      } else {
        returnVal = this.pd_content.overlay_exit_link.all_accounts_url;
      }
      return returnVal;
    },
    getSecondaryButtonLabel() {
      let buttonText = this.pd_content.secondary_button.default;
      if (this.cs_editMode) {
        buttonText = this.pd_content.secondary_button.edit;
      }
      return buttonText;
    },
    getPrimaryButtonLabel() {
      let buttonText = this.pd_content.primary_button.default;
      if (this.cs_editMode) {
        buttonText = this.pd_content.primary_button.edit;
      } else if (this.cs_stateName === 'review-and-confirm') {
        buttonText = this.pd_content.primary_button.confirm;
      } else if (this.cs_stateName === 'agree-to-terms') {
        buttonText = this.pd_content.primary_button.open;
      } else if (!this.isRepOnRCPage() && this.isPrimaryActionDisabled) {
        buttonText = this.pd_content.primary_button.wait;
      }
      return buttonText;
    },
  },
};
